<template>
  <TeamForm
    :title="$t('string.add_team')"
  />
</template>

<script>
import TeamForm from './Form'

export default {
  name: 'Create',
  metaInfo () {
    return {
      title: this.$t('string.add_team'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  components: { TeamForm }
}
</script>

<style scoped>

</style>
